import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import { logoPng as logoImg } from '../images/assets';

function Navbar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);
  const handleClick = (e) => {
    setClick(!click);
    e.preventDefault()
    const target = e.target.getAttribute('href')
    if(!target) return;
    const location = document.querySelector(target).offsetTop

 
    window.scrollTo({
      left: 0,
      top: location 
    })
    
  }
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);    
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
            <img src={logoImg} alt="Logo" className="navbar-logo"/>
          </Link>
          <div className='menu-icon' onClick={handleClick}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
          <li className='nav-item'>
         
         <Link className='nav-links' to='/'>
          Home
         </Link>
       </li>
            <li className='nav-item'>
            <Link className='nav-links' to='/'>
              {/* <p className='nav-links' href='#services' key='services' onClick={handleClick}> */}
               Services
               </Link>

              {/* </p> */}
            </li>

            <li className='nav-item'>
         
              <Link className='nav-links' to='/projects'>
               Projects
              </Link>
            </li>
            <li className='nav-item'>
            <Link className='nav-links' to='/'>
            {/* <p className='nav-links' href='#about' key='about' onClick={handleClick}> */}
               About
               </Link>

              {/* </p> */}
            </li>
            <li className='nav-item'>
            <p className='nav-links' href='#contact' key='contact' onClick={handleClick}>
               Contact Us
              </p>
            </li>

            
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
